import React, {memo, useEffect, useRef, useState} from "react";
import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";
import {FaTimes} from "react-icons/fa";
import Button from "../../../components/button";
import {saveData} from "../hooks/save-data";
import {normalizeQuickFilterText} from "../../../utils/ag-grid-quick-filter";

export default memo((props) => {
    const {value, api, data, target, selectOptions, selectionMode = "multi"} = props;
    const searchRef = useRef();
    const isSingleSelection = selectionMode === "single";
    const normalizeValue = (currentValue) => {
        if (!currentValue) return [];

        if (Array.isArray(currentValue)) {
            return currentValue.map((item) => ({value: item.id, label: item.name}));
        }

        return [{value: currentValue.id, label: currentValue.name}];
    };

    const valueFormated = normalizeValue(value);

    const [selectedOptions, setSelectedOptions] = useState(valueFormated);
    const [open, setOpen] = useState(false);

    const title = () => {
        switch (target) {
            case "groups":
                return "Grupos"
            case "projects":
                return "Projetos"
            case "devs":
                return "Devs"
            case "responsible":
                return "Atendente"
            default:
                return ""

        }
    }

    const options = selectOptions;

    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        if (open) {
            setTimeout(() => {
                searchRef?.current?.select();
            }, 0)
        }
    }, [open]);

    useEffect(() => {
        setSelectedOptions(normalizeValue(value));
    }, [value]);

    const handleOptionClick = (option) => {
        const find = selectedOptions.find(s => s.value === option.value);
        if (find) {
            const newOptions = selectedOptions.filter((s) => s.value !== option.value);
            setSelectedOptions([...newOptions])
        } else if (isSingleSelection) {
            setSelectedOptions([option]);
        } else {
            setSelectedOptions([...selectedOptions, option])
        }

        searchRef.current?.select();
        setSearchTerm("");
    };

    const filteredOptions = options?.filter((option) =>
        normalizeQuickFilterText(option.label).includes(normalizeQuickFilterText(searchTerm))
    );

    const searchItem = ({target: {value}}) => {
        setSearchTerm(value);
    }

    const save = () => {
        const selectedValues = selectedOptions.map(i => {
            return {id: i.value, name: i.label}
        });

        data[target] = isSingleSelection ? (selectedValues[0] ?? null) : selectedValues;
        api.applyTransaction({update: [data]});

        saveData(data);
        setOpen(false);
    }

    const displayValue = isSingleSelection
        ? value?.name ?? ""
        : Array.isArray(value) ? value.map(g => g.name).join(", ") : "";

    return (
        <>
            {
                displayValue &&
                <div className={"w-full"} onClick={() => setOpen(!open)}>
                    {displayValue}
                </div>
            }

            {
                value !== undefined &&
                <div className={"w-full h-full min-h-[32px] absolute top-0 left-0"} onClick={() => setOpen(!open)}>
                </div>
            }


            <Dialog open={open} onClose={setOpen} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-5/12 m-auto">
                    <div className="flex min-h-full items-start justify-center p-4 text-center sm:items-start sm:p-4">
                        <DialogPanel transition
                                     className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 w-9/12 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95">
                            <div className="bg-white border-b border-gray-300">
                                <div className="text-left">
                                    <DialogTitle as="h3"
                                                 className="font-semibold leading-6 border-b border-gray-300 p-2 flex justify-between">
                                        {title()}
                                        <span onClick={() => setOpen(false)} className="cursor-pointer">
                                        <FaTimes/>
                                    </span>
                                    </DialogTitle>
                                    <div className="p-2">
                                        <div
                                            className={"flex flex-wrap gap-2 p-1 cursor-pointer border"}>
                                            {
                                                selectedOptions.map((option, index) => {
                                                    return (
                                                        <span key={index}
                                                              className="bg-[#e7e7e7] text-blue-800 text-sm rounded-sm px-2 flex items-center gap-1">
                                                            {option.label}
                                                            <button
                                                                className="text-gray-500"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleOptionClick(option);
                                                                }}
                                                            > <FaTimes/>
                                                      </button>
                                                    </span>
                                                    )
                                                })
                                            }
                                            <input type="text" onChange={searchItem} ref={searchRef}
                                                   className={"focus-visible:outline-none"}/>
                                        </div>

                                        <div className="overflow-y-auto max-h-[calc(100vh-261px)] border -mt-[1px]">
                                            {filteredOptions?.length > 0 ? (
                                                filteredOptions.map((option, index) => (
                                                    <div
                                                        key={index}
                                                        onClick={() => handleOptionClick(option)}
                                                        className={`p-1 cursor-pointer hover:bg-[#e7e7e7] ${
                                                            selectedOptions.find(s => s.value === option.value) ? "bg-[#e7e7e7]" : ""
                                                        }`}
                                                    >
                                                        {option.label}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="text-gray-500 p-1">Não encontrado</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className={"body border-t border-gray-300 p-2 flex justify-end"}>
                                        <Button onClick={() => setOpen(false)} target="warning"
                                                col={"col-span-2 mr-2"}>
                                            Cancelar
                                        </Button>
                                        <Button onClick={save} target="primary" col={"col-span-2"}>
                                            Ok
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
});
